/**
 * Emoji Data
 * Popular emojis for wallet avatars, organized by category
 */

export const EMOJI_LIST = [
  // Faces & expressions
  "😀", "😃", "😄", "😁", "😆", "😅",
  "🤣", "😂", "🙂", "😉", "😊", "😇",
  "🥰", "😍", "🤩", "😘", "😗", "😚",
  "😋", "😛", "😜", "🤪", "😝", "🤑",
  "🤗", "🤭", "🤫", "🤔", "🤐", "🤨",
  "😐", "😑", "😶", "😏", "😒", "🙄",
  "😬", "🤥", "😌", "😔", "😪", "🤤",
  "😴", "😷", "🤒", "🤕", "🤢", "🤮",
  "🤧", "🥵", "🥶", "🥴", "😵", "🤯",
  "🤠", "🥳", "🥸", "😎", "🤓", "🧐",
  "😕", "😟", "🙁", "😮", "😯", "😲",
  "😳", "🥺", "😦", "😧", "😨", "😰",
  "😥", "😢", "😭", "😱", "😖", "😣",
  "😞", "😓", "😩", "😫", "🥱", "😤",
  "😡", "😠", "🤬", "😈", "👿", "💀",
  "☠️", "💩", "🤡", "👹", "👺", "👻",
  "👽", "👾", "🤖", "🫠", "🫡", "🫢",
  "🫣", "🫤", "🫥", "🫨", "🙈", "🙉",
  "🙊", "💋", "💌", "💘", "💝", "💖",
  "💗", "💓", "💞", "💕", "💟", "❣️",
  "💔", "❤️‍🔥", "❤️‍🩹", "❤️", "🧡", "💛",
  "💚", "💙", "💜", "🤎", "🖤", "🤍",
  // People & gestures
  "👋", "🤚", "🖐️", "✋", "🖖", "👌",
  "🤌", "🤏", "✌️", "🤞", "🤟", "🤘",
  "🤙", "👈", "👉", "👆", "🖕", "👇",
  "☝️", "👍", "👎", "✊", "👊", "🤛",
  "🤜", "👏", "🙌", "👐", "🤲", "🤝",
  "🙏", "✍️", "💅", "🤳", "💪", "🦾",
  "🦿", "🦵", "🦶", "👂", "🦻", "👃",
  "🧠", "🫀", "🫁", "🦷", "🦴", "👀",
  "👁️", "👅", "👄", "🫦", "👶", "🧒",
  "👦", "👧", "🧑", "👱", "👨", "🧔",
  "👩", "🧓", "👴", "👵", "🙍", "🙎",
  "🙅", "🙆", "💁", "🙋", "🧏", "🙇",
  "🤦", "🤷", "🧑‍⚕️", "🧑‍🎓", "🧑‍🏫", "🧑‍⚖️",
  "🧑‍🌾", "🧑‍🍳", "🧑‍🔧", "🧑‍🔬", "🧑‍💻", "🧑‍🎤",
  "🧑‍🎨", "🧑‍✈️", "🧑‍🚀", "🧑‍🚒", "👮", "🕵️",
  "💂", "🥷", "👷", "🤴", "👸", "👳",
  "👲", "🧕", "🤵", "👰", "🤰", "🤱",
  "👼", "🎅", "🤶", "🦸", "🦹", "🧙",
  "🧚", "🧛", "🧜", "🧝", "🧞", "🧟",
  "🧌", "💆", "💇", "🚶", "🧍", "🧎",
  "🏃", "💃", "🕺", "🕴️", "👯", "🧖",
  "🧗", "🤸", "🏌️", "🏇", "⛷️", "🏂",
  // Animals
  "🐵", "🐒", "🦍", "🦧", "🐶", "🐕",
  "🦮", "🐕‍🦺", "🐩", "🐺", "🦊", "🦝",
  "🐱", "🐈", "🐈‍⬛", "🦁", "🐯", "🐅",
  "🐆", "🐴", "🐎", "🦄", "🦓", "🦌",
  "🦬", "🐮", "🐂", "🐃", "🐄", "🐷",
  "🐖", "🐗", "🐽", "🐏", "🐑", "🐐",
  "🐪", "🐫", "🦙", "🦒", "🐘", "🦣",
  "🦏", "🦛", "🐭", "🐁", "🐀", "🐹",
  "🐰", "🐇", "🐿️", "🦫", "🦔", "🦇",
  "🐻", "🐻‍❄️", "🐨", "🐼", "🦥", "🦦",
  "🦨", "🦘", "🦡", "🐾", "🦃", "🐔",
  "🐓", "🐣", "🐤", "🐥", "🐦", "🐧",
  "🕊️", "🦅", "🦆", "🦢", "🦉", "🦤",
  "🪶", "🦩", "🦚", "🦜", "🐸", "🐊",
  "🐢", "🦎", "🐍", "🐲", "🐉", "🦕",
  "🦖", "🐳", "🐋", "🐬", "🦭", "🐟",
  "🐠", "🐡", "🦈", "🐙", "🐚", "🐌",
  "🦋", "🐛", "🐜", "🐝", "🪲", "🐞",
  "🦗", "🪳", "🕷️", "🕸️", "🦂", "🦟",
  "🪰", "🪱", "🦠", "🦑", "🦐", "🦞",
  "🦀", "🦆", "🦢", "🦩", "🦚", "🦜",
  // Nature & space
  "💐", "🌸", "💮", "🏵️", "🌹", "🥀",
  "🌺", "🌻", "🌼", "🌷", "🌱", "🪴",
  "🌲", "🌳", "🌴", "🌵", "🌾", "🌿",
  "☘️", "🍀", "🍁", "🍂", "🍃", "🎍",
  "🎋", "🍇", "🍈", "🍉", "🍊", "🍋",
  "🍌", "🍍", "🥭", "🍎", "🍏", "🍐",
  "🍑", "🍒", "🍓", "🫐", "🥝", "🍅",
  "🫒", "🥥", "🥑", "🍆", "🥔", "🥕",
  "🌽", "🌶️", "🫑", "🥒", "🥬", "🥦",
  "🧄", "🧅", "🍄", "🥜", "🫘", "🌰",
  "🌍", "🌎", "🌏", "🌐", "🗺️", "🧭",
  "🏔️", "⛰️", "🌋", "🗻", "🏕️", "🏖️",
  "🏜️", "🏝️", "🏞️", "🌅", "🌄", "🌠",
  "🎇", "🎆", "🌇", "🌆", "🏙️", "🌃",
  "🌌", "🌉", "🌁", "🌀", "🌈", "🌊",
  "⭐", "🌟", "💫", "✨", "☀️", "🌤️",
  "⛅", "🌥️", "☁️", "🌦️", "🌧️", "⛈️",
  "🌩️", "🌨️", "❄️", "☃️", "⛄", "🌬️",
  "💨", "🌪️", "🌫️", "🔥", "💥", "💢",
  "🌙", "🌛", "🌜", "🌚", "🌕", "🌖",
  "🌗", "🌘", "🌑", "🌒", "🌓", "🌔",
  "🪐", "💎", "☄️", "⚡", "💧", "🚀",
  // Food & drink
  "🍞", "🥐", "🥖", "🫓", "🥨", "🥯",
  "🥞", "🧇", "🧀", "🍖", "🍗", "🥩",
  "🥓", "🍔", "🍟", "🍕", "🌭", "🥪",
  "🌮", "🌯", "🫔", "🥙", "🧆", "🥚",
  "🍳", "🥘", "🍲", "🫕", "🥣", "🥗",
  "🍿", "🧈", "🧂", "🥫", "🍱", "🍘",
  "🍙", "🍚", "🍛", "🍜", "🍝", "🍠",
  "🍢", "🍣", "🍤", "🍥", "🥮", "🍡",
  "🥟", "🥠", "🥡", "🦀", "🦞", "🦐",
  "🦑", "🦪", "🍦", "🍧", "🍨", "🍩",
  "🍪", "🎂", "🍰", "🧁", "🥧", "🍫",
  "🍬", "🍭", "🍮", "🍯", "🍼", "🥛",
  "☕", "🫖", "🍵", "🍶", "🍾", "🍷",
  "🍸", "🍹", "🍺", "🍻", "🥂", "🥃",
  "🫗", "🥤", "🧋", "🧃", "🧉", "🧊",
  // Objects & symbols
  "⌚", "📱", "📲", "💻", "⌨️", "🖥️",
  "🖨️", "🖱️", "🖲️", "🕹️", "🗜️", "💽",
  "💾", "💿", "📀", "📼", "📷", "📸",
  "📹", "🎥", "📽️", "🎞️", "📞", "☎️",
  "📟", "📠", "📺", "📻", "🎙️", "🎚️",
  "🎛️", "🧭", "⏱️", "⏲️", "⏰", "🕰️",
  "⌛", "⏳", "📡", "🔋", "🔌", "💡",
  "🔦", "🕯️", "🪔", "🧯", "🛢️", "💸",
  "💵", "💴", "💶", "💷", "🪙", "💰",
  "💳", "💎", "⚖️", "🪜", "🧰", "🪛",
  "🔧", "🔨", "⚒️", "🛠️", "⛏️", "🪚",
  "🔩", "⚙️", "🪤", "🧱", "⛓️", "🧲",
  "🔫", "💣", "🧨", "🪓", "🔪", "🗡️",
  "⚔️", "🛡️", "🚬", "⚰️", "🪦", "⚱️",
  "🏺", "🔮", "📿", "🧿", "💈", "⚗️",
  "🔭", "🔬", "🕳️", "🩹", "🩺", "💊",
  "💉", "🩸", "🧬", "🦠", "🧫", "🧪",
  "🌡️", "🧹", "🪠", "🧺", "🧻", "🚽",
  "🚰", "🚿", "🛁", "🛀", "🧼", "🪥",
  "🪒", "🧽", "🪣", "🧴", "🛎️", "🔑",
  "🗝️", "🚪", "🪑", "🛋️", "🛏️", "🛌",
  "🧸", "🪆", "🖼️", "🪞", "🪟", "🛍️",
  "🛒", "🎁", "🎈", "🎏", "🎀", "🪄",
  "🪅", "🎊", "🎉", "🎎", "🏮", "🎐",
  "🧧", "✉️", "📩", "📨", "📧", "💌",
  "📥", "📤", "📦", "🏷️", "🪧", "📪",
  "📫", "📬", "📭", "📮", "📯", "📜",
  "📃", "📄", "📑", "🧾", "📊", "📈",
  "📉", "🗒️", "🗓️", "📆", "📅", "🗑️",
  "📇", "🗃️", "🗳️", "🗄️", "📋", "📁",
  "📂", "🗂️", "🗞️", "📰", "📓", "📔",
  "📒", "📕", "📗", "📘", "📙", "📚",
  "📖", "🔖", "🧷", "🔗", "📎", "🖇️",
  "📐", "📏", "🧮", "📌", "📍", "✂️",
  "🖊️", "🖋️", "✒️", "🖌️", "🖍️", "📝",
  "✏️", "🔍", "🔎", "🔏", "🔐", "🔒",
  "🔓", "🏆", "🥇", "🥈", "🥉", "🏅",
  "🎖️", "🏵️", "🎗️", "🎫", "🎟️", "🎪",
  // Sports & activities
  "⚽", "🏀", "🏈", "⚾", "🥎", "🎾",
  "🏐", "🏉", "🥏", "🎱", "🪀", "🏓",
  "🏸", "🏒", "🏑", "🥍", "🏏", "🪃",
  "🥅", "⛳", "🪁", "🏹", "🎣", "🤿",
  "🥊", "🥋", "🎽", "🛹", "🛼", "🛷",
  "⛸️", "🥌", "🎿", "⛷️", "🏂", "🪂",
  "🏋️", "🤼", "🤽", "🤾", "🤺", "⛹️",
  "🧘", "🏄", "🏊", "🚣", "🧗", "🚴",
  "🚵", "🎮", "🕹️", "🎲", "🎯", "🎳",
  "🎰", "🧩", "♟️", "🃏", "🀄", "🎴",
  // Music & entertainment
  "🎭", "🖼️", "🎨", "🧵", "🪡", "🧶",
  "🪢", "🎼", "🎵", "🎶", "🎹", "🥁",
  "🪘", "🎷", "🎺", "🪗", "🎸", "🪕",
  "🎻", "🪈", "🎤", "🎧", "📻", "🎬",
  "🎦", "🎞️", "📽️", "📹", "📺", "📸",
  // Vehicles & travel
  "🚗", "🚕", "🚙", "🚌", "🚎", "🏎️",
  "🚓", "🚑", "🚒", "🚐", "🛻", "🚚",
  "🚛", "🚜", "🦯", "🦽", "🦼", "🛴",
  "🚲", "🛵", "🏍️", "🛺", "🚨", "🚔",
  "🚍", "🚘", "🚖", "🚡", "🚠", "🚟",
  "🚃", "🚋", "🚞", "🚝", "🚄", "🚅",
  "🚈", "🚂", "🚆", "🚇", "🚊", "🚉",
  "✈️", "🛫", "🛬", "🛩️", "💺", "🛰️",
  "🚀", "🛸", "🚁", "🛶", "⛵", "🚤",
  "🛥️", "🛳️", "⛴️", "🚢", "⚓", "🪝",
  "⛽", "🚧", "🚦", "🚥", "🚏", "🗺️",
  "🗿", "🗽", "🗼", "🏰", "🏯", "🏟️",
  "🎡", "🎢", "🎠", "⛲", "⛱️", "🏖️",
  // Buildings & places
  "🏘️", "🏚️", "🏗️", "🏭", "🏢", "🏬",
  "🏣", "🏤", "🏥", "🏦", "🏨", "🏩",
  "🏪", "🏫", "🏛️", "💒", "🕌", "🕍",
  "🛕", "⛪", "🕋", "⛩️", "🛤️", "🛣️",
  // Flags & symbols
  "🏁", "🚩", "🎌", "🏴", "🏳️", "🏳️‍🌈",
  "🏳️‍⚧️", "🏴‍☠️", "♈", "♉", "♊", "♋",
  "♌", "♍", "♎", "♏", "♐", "♑",
  "♒", "♓", "⛎", "🔀", "🔁", "🔂",
  "▶️", "⏩", "⏭️", "⏯️", "◀️", "⏪",
  "⏮️", "🔼", "⏫", "🔽", "⏬", "⏸️",
  "⏹️", "⏺️", "⏏️", "🎦", "🔅", "🔆",
  "📶", "📳", "📴", "♀️", "♂️", "⚧️",
  "✖️", "➕", "➖", "➗", "🟰", "♾️",
  "‼️", "⁉️", "❓", "❔", "❕", "❗",
  "〰️", "💱", "💲", "⚕️", "♻️", "⚜️",
  "🔱", "📛", "🔰", "⭕", "✅", "☑️",
  "✔️", "❌", "❎", "➰", "➿", "〽️",
  "✳️", "✴️", "❇️", "©️", "®️", "™️",
  "🔴", "🟠", "🟡", "🟢", "🔵", "🟣",
  "🟤", "⚫", "⚪", "🟥", "🟧", "🟨",
  "🟩", "🟦", "🟪", "🟫", "⬛", "⬜",
  "◼️", "◻️", "◾", "◽", "▪️", "▫️",
  "🔶", "🔷", "🔸", "🔹", "🔺", "🔻",
  "💠", "🔘", "🔳", "🔲", "👁️‍🗨️", "🗨️",
  "💬", "👁️", "👑", "💍", "🎭", "🎯",
]
